import {Component, Input} from '@angular/core';
import {
    APP_CONFIG,
    AuthService,
    BlockAbstractComponent,
    PageService,
    PageType,
    ParserService
} from '@gallaghercp/core-frontend';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
    selector: 'core-one-page-footer',
    templateUrl: './one-page-footer.component.html',
    styleUrls: ['./one-page-footer.component.scss'],
    standalone: false,
})
export class OnePageFooterComponent extends BlockAbstractComponent {
    @Input() page?: PageType;
    @Input() logo?: any;

    footerLogoPath: string = '../../../../assets/img/gallagher-logo.svg';
    appName: string = APP_CONFIG.appName;
    copyright = APP_CONFIG.copyright;
    simpleFooter: boolean = false;

    footerLinks: { text: string; url: string; target?: '_self' | '_blank' }[] = [
        {
            text: 'Cookie Policy',
            url: '//policy.cookiereports.com/905eb273-en-gb.html',
        },
    ];

    footerLinksLower: { text: string; url: string; target?: '_self' | '_blank' }[] = [
        {
            text: 'Gallagher',
            url: 'https://ajg.com/employeeexperience',
            target: '_blank',
        },
    ];

    constructor(
        protected override parser: ParserService,
        protected override pages: PageService,
        protected override auth: AuthService,
        protected breakpoint: BreakpointObserver,
    ) {
        super(parser, auth, pages);
    }

    override ngOnInit() {
        super.ngOnInit();
        if (this.page) {
            if (this.page.meta?.['privacyPolicy']) {
                this.footerLinks.push({
                    text: 'Privacy Policy',
                    url: this.page.meta?.['privacyPolicy'],
                    target: '_blank',
                });
            }
            if (this.page.meta?.['terms']) {
                this.footerLinks.push({
                    text: 'Terms of Use',
                    url: this.page.meta?.['terms'],
                    target: '_blank',
                });
            }
            if (this.page.meta?.['simpleFooter']) {
                this.simpleFooter = true;
            }
        }
    }
}
